<div class="shop-apply" [class.shop-apply--page]="page">

    <!-- Head and foot stay put; only the fields between them scroll, so Send is always in reach. -->
    <div class="shop-apply__head">
        <div class="shop-apply__heading">
            <!-- On its own page the card's title is the page's heading. -->
            <h1 class="shop-apply__title" *ngIf="page">{{ 'apply-to-sell-on' | t:'Apply to sell on {brand}':{ brand: brand.name } }}</h1>
            <h5 class="shop-apply__title" *ngIf="!page">{{ isClaim ? ('claim-this-shop' | t:'Claim this shop') : ('sell-on-brand' | t:'Sell on {brand}':{ brand: brand.name }) }}</h5>
            <p class="shop-apply__subtitle" *ngIf="!isClaim">
                {{ 'seller-apply-intro' | t:'Tell us about yourself and your shop. Applying is free, and we reply to every application by email.' }}
            </p>
            <p class="shop-apply__subtitle" *ngIf="isClaim">
                <ng-container *ngIf="('seller-claim-confirm-own-verify' | tAround:'Confirm you own {shop} and we\'ll verify it, so you can manage its page, logo and products yourself.':'shop') as p">{{ p[0] }}<strong>{{ store?.name }}</strong>{{ p[1] }}</ng-container>
            </p>
        </div>
        <button *ngIf="!page" type="button" class="shop-apply__close" [attr.aria-label]="'close' | t:'Close'" (click)="close()">
            <app-icon name="cross-12" size="12"></app-icon>
        </button>
    </div>

    <form *ngIf="!done; else sentPanel" class="shop-apply__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="shop-apply__body">
            <!-- The details, until a code has been texted to the phone. -->
            <ng-container *ngIf="step === 'form'">

            <!-- Who you are. Same three fields in both modes. -->
            <section class="shop-apply__section">
                <h6 class="shop-apply__section-title">{{ 'seller-apply-your-details' | t:'Your details' }}</h6>

                <div class="form-group">
                    <label for="sa-name">{{ 'full-name' | t:'Full name' }}</label>
                    <input id="sa-name" type="text" class="form-control" formControlName="name"
                           autocomplete="name" [class.is-invalid]="invalid('name')">
                    <div class="invalid-feedback" *ngIf="invalid('name')">{{ 'seller-apply-name-required' | t:'Please tell us your name.' }}</div>
                </div>

                <div class="shop-apply__row">
                    <div class="form-group">
                        <label for="sa-email">{{ 'email' | t:'Email' }}</label>
                        <input id="sa-email" type="email" class="form-control" formControlName="email"
                               autocomplete="email" [class.is-invalid]="invalid('email')">
                        <div class="invalid-feedback" *ngIf="invalid('email')">
                            {{ form.get('email').hasError('required') ? ('seller-apply-email-required' | t:'An email address is required.') : ('seller-apply-email-invalid' | t:'That email address does not look right.') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="sa-phone">{{ 'phone' | t:'Phone' }}</label>
                        <input id="sa-phone" type="tel" class="form-control" formControlName="phone" inputmode="tel"
                               autocomplete="tel" [class.is-invalid]="invalid('phone')">
                        <small class="shop-apply__hint" *ngIf="!invalid('phone')">{{ 'seller-apply-phone-hint-bd' | t:'Your mobile number. We text it a code to check it.' }}</small>
                        <div class="invalid-feedback" *ngIf="invalid('phone')">
                            {{ form.get('phone').hasError('required') ? ('seller-apply-phone-required' | t:'A phone number is required.') : ('seller-apply-phone-bd' | t:'Enter a Bangladesh mobile number, like 01712-345678.') }}
                        </div>
                    </div>
                </div>
            </section>

            <!-- The shop. Read-only when claiming one that is already listed. -->
            <section class="shop-apply__section">
                <h6 class="shop-apply__section-title">{{ isClaim ? ('seller-apply-the-shop' | t:'The shop') : ('seller-apply-your-shop' | t:'Your shop') }}</h6>

                <div class="shop-apply__row" [class.shop-apply__row--single]="isClaim">
                    <div class="form-group">
                        <label for="sa-shop">{{ 'shop-name' | t:'Shop name' }}</label>
                        <input id="sa-shop" type="text" class="form-control" formControlName="storeName"
                               autocomplete="organization" [readonly]="isClaim" [class.is-invalid]="invalid('storeName')">
                        <small class="shop-apply__hint" *ngIf="!isClaim && !invalid('storeName')">{{ 'seller-apply-shop-name-hint' | t:'The name buyers will see.' }}</small>
                        <div class="invalid-feedback" *ngIf="invalid('storeName')">{{ 'seller-apply-shop-name-required' | t:'A shop name is required.' }}</div>
                    </div>

                    <div class="form-group" *ngIf="!isClaim">
                        <label for="sa-category">{{ 'seller-apply-what-sell' | t:'What do you sell?' }}</label>
                        <select id="sa-category" class="form-control" formControlName="category"
                                [class.is-invalid]="invalid('category')">
                            <option value="" disabled>{{ 'choose-a-category' | t:'Choose a category' }}</option>
                            <option *ngFor="let cat of categories" [value]="cat.slug">{{ cat.name }}</option>
                        </select>
                        <small class="shop-apply__hint" *ngIf="!categoriesFailed && !invalid('category')">
                            {{ 'seller-apply-category-hint' | t:'The closest one. You can sell in more later.' }}
                        </small>
                        <small class="shop-apply__hint" *ngIf="categoriesFailed">
                            {{ 'seller-apply-categories-failed' | t:'The list did not load. You can still apply and tell us below.' }}
                        </small>
                        <div class="invalid-feedback" *ngIf="invalid('category')">{{ 'seller-apply-category-required' | t:'Please choose a category.' }}</div>
                    </div>
                </div>

                <div class="form-group" *ngIf="!isClaim">
                    <label for="sa-website">{{ 'seller-apply-website' | t:'Website or social page' }} <span class="shop-apply__optional">{{ 'optional' | t:'Optional' }}</span></label>
                    <input id="sa-website" type="text" class="form-control" formControlName="website"
                           autocomplete="url" [attr.placeholder]="'seller-apply-website-placeholder' | t:'yourshop.com or facebook.com/yourshop'">
                </div>

                <div class="form-group" *ngIf="!isClaim">
                    <label for="sa-about">{{ 'seller-apply-about' | t:'About your shop' }} <span class="shop-apply__optional">{{ 'optional' | t:'Optional' }}</span></label>
                    <textarea id="sa-about" class="form-control" rows="3" formControlName="about" maxlength="400"
                              [attr.placeholder]="'seller-apply-about-placeholder' | t:'What you sell, the brands you carry, how long you have been selling'"></textarea>
                    <small class="shop-apply__count">{{ (form.get('about').value || '').length }}/400</small>
                </div>
            </section>

            <!-- Where the shop is. -->
            <section class="shop-apply__section">
                <h6 class="shop-apply__section-title">{{ 'seller-apply-where-based' | t:'Where you\'re based' }}</h6>

                <div class="shop-apply__row" [class.shop-apply__row--single]="isClaim">
                    <div class="form-group" *ngIf="!isClaim">
                        <label for="sa-country">{{ 'country' | t:'Country' }}</label>
                        <select id="sa-country" class="form-control" formControlName="country" autocomplete="country"
                                [class.is-invalid]="invalid('country')">
                            <option value="" disabled>{{ 'choose-your-country' | t:'Choose your country' }}</option>
                            <option *ngFor="let c of countries" [value]="c.ValueText">{{ c.Name }}</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="invalid('country')">{{ 'seller-apply-country-required' | t:'Please choose your country.' }}</div>
                    </div>

                    <div class="form-group">
                        <label for="sa-location">{{ 'city-or-area' | t:'City or area' }}</label>
                        <input id="sa-location" type="text" class="form-control" formControlName="storeLocation"
                               autocomplete="address-level2" [readonly]="isClaim" [class.is-invalid]="invalid('storeLocation')">
                        <div class="invalid-feedback" *ngIf="invalid('storeLocation')">{{ 'seller-apply-city-required' | t:'A city or area is required.' }}</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="sa-address">{{ 'address' | t:'Address' }}</label>
                    <textarea id="sa-address" class="form-control" rows="2" formControlName="storeAddress"
                              autocomplete="street-address" [readonly]="isClaim" [class.is-invalid]="invalid('storeAddress')"
                              [placeholder]="isClaim ? '' : ('seller-apply-address-placeholder' | t:'Street, building, postcode')"></textarea>
                    <div class="invalid-feedback" *ngIf="invalid('storeAddress')">{{ 'seller-apply-address-required' | t:'An address is required.' }}</div>
                </div>
            </section>

            <!-- The agreement: part of applying (and of a claim). The server refuses without it and keeps the moment. -->
            <div class="form-group shop-apply__agree">
                <div class="form-check">
                    <span class="form-check-input input-check" [class.is-invalid]="invalid('agreed')">
                        <span class="input-check__body">
                            <input class="input-check__input" type="checkbox" id="sa-agree" formControlName="agreed">
                            <span class="input-check__box"></span>
                            <app-icon class="input-check__icon" name="check-9x7" size="9x7"></app-icon>
                        </span>
                    </span>
                    <label class="form-check-label" for="sa-agree">
                        <ng-container *ngIf="('seller-apply-agree-terms-true' | tAround:'I agree to the {terms} and confirm the details above are true.':'terms') as p">{{ p[0] }}<a href="/terms" target="_blank" rel="noopener">{{ 'seller-apply-terms-link' | t:'Terms and Conditions' }}</a>{{ p[1] }}</ng-container>
                    </label>
                </div>
                <div class="invalid-feedback" *ngIf="invalid('agreed')">{{ 'seller-apply-agree-required' | t:'Please agree to the terms to continue.' }}</div>
            </div>

            <p class="shop-apply__footnote">
                {{ isClaim ? ('seller-apply-review-claim' | t:'We use these details only to review your claim.') : ('seller-apply-review-application' | t:'We use these details only to review your application.') }}
                <a href="/privacy" target="_blank" rel="noopener">{{ 'privacy-policy' | t:'Privacy Policy' }}</a>
            </p>
            </ng-container>

            <!-- The phone code (PhoneCodes on the server): texted once the details are complete; the application or claim
                 goes with it. "Send again" waits out the minute; "Change the number" goes back to the details. -->
            <section class="shop-apply__section shop-apply__code" *ngIf="step === 'code'">
                <h6 class="shop-apply__section-title">{{ 'seller-apply-check-phone' | t:'Check your phone' }}</h6>
                <p class="shop-apply__code-text">
                    <ng-container *ngIf="!isClaim && ('seller-apply-code-sent-to' | tAround:'We texted a 6-digit code to {phone}. Enter it to send your application.':'phone') as p">{{ p[0] }}<strong class="shop-apply__code-phone">{{ codePhone }}</strong>{{ p[1] }}</ng-container>
                    <ng-container *ngIf="isClaim && ('seller-claim-code-sent-to' | tAround:'We texted a 6-digit code to {phone}. Enter it to send your claim.':'phone') as p">{{ p[0] }}<strong class="shop-apply__code-phone">{{ codePhone }}</strong>{{ p[1] }}</ng-container>
                </p>

                <div class="form-group shop-apply__code-field">
                    <label for="sa-code">{{ 'seller-apply-code-label' | t:'Code' }}</label>
                    <input id="sa-code" type="text" class="form-control shop-apply__code-input" [formControl]="code"
                           inputmode="numeric" autocomplete="one-time-code" maxlength="8" spellcheck="false"
                           [class.is-invalid]="codeError" (input)="codeError = null">
                    <div class="invalid-feedback" *ngIf="codeError">{{ codeError }}</div>
                </div>

                <div class="shop-apply__code-actions">
                    <button type="button" class="shop-apply__code-link" [disabled]="resendIn > 0 || calling" (click)="resend()">
                        {{ resendIn > 0 ? ('seller-apply-send-again-in' | t:'Send the code again in {n} s':{ n: resendIn }) : ('seller-apply-send-again' | t:'Send the code again') }}
                    </button>
                    <button type="button" class="shop-apply__code-link" [disabled]="calling" (click)="changeNumber()">{{ 'seller-apply-change-number' | t:'Change the number' }}</button>
                </div>
            </section>
        </div>

        <div class="shop-apply__foot">
            <button *ngIf="!page" type="button" class="btn btn-secondary" (click)="close()">{{ 'cancel' | t:'Cancel' }}</button>
            <button type="submit" class="btn btn-primary" [disabled]="calling" [ngClass]="{'btn-loading': calling}">
                <ng-container *ngIf="step === 'form'">{{ isClaim ? ('seller-apply-send-claim' | t:'Send claim') : ('seller-apply-send-application' | t:'Send application') }}</ng-container>
                <ng-container *ngIf="step === 'code'">{{ isClaim ? ('seller-claim-verify-send' | t:'Verify and send claim') : ('seller-apply-verify-send' | t:'Verify and send application') }}</ng-container>
            </button>
        </div>
    </form>

    <!-- Sent: said in the form itself, with what happens next. -->
    <ng-template #sentPanel>
        <div class="shop-apply__body shop-apply__done">
            <app-icon class="shop-apply__done-icon" name="check-100" size="100"></app-icon>
            <h5 class="shop-apply__done-title">{{ done?.claim ? ('seller-apply-claim-received' | t:'Claim received') : ('seller-apply-application-received' | t:'Application received') }}</h5>
            <p class="shop-apply__done-text">
                {{ done?.name ? ('thank-you-name' | t:'Thank you, {name}.':{ name: done.name }) : ('thank-you-sentence' | t:'Thank you.') }}
                <ng-container *ngIf="done?.claim"><ng-container *ngIf="('seller-apply-review-write-to-verify' | tAround:'We\'ll review {shop} and write to {email} to verify it is yours.':['shop', 'email']) as p">{{ p[0] }}<strong>{{ done?.shop }}</strong>{{ p[1] }}<strong>{{ done?.email }}</strong>{{ p[2] }}</ng-container></ng-container>
                <ng-container *ngIf="!done?.claim"><ng-container *ngIf="('seller-apply-review-write-answer' | tAround:'We\'ll review {shop} and write to {email} with our answer.':['shop', 'email']) as p">{{ p[0] }}<strong>{{ done?.shop }}</strong>{{ p[1] }}<strong>{{ done?.email }}</strong>{{ p[2] }}</ng-container></ng-container>
            </p>
        </div>
        <div class="shop-apply__foot" *ngIf="!page">
            <button type="button" class="btn btn-primary" (click)="close()">{{ 'close' | t:'Close' }}</button>
        </div>
    </ng-template>
</div>
